/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxcCorpactionsCaadminV1PaymentState } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXC_CORPACTIONS_CAADMIN_V1_PAYMENT_STATE_ENTITY_NAME = 'ixc.corpactions.caadmin.v1.Payment';
export const ixcCorpactionsCaadminV1PaymentStateEntity = new schema.Entity<IxcCorpactionsCaadminV1PaymentState>(IXC_CORPACTIONS_CAADMIN_V1_PAYMENT_STATE_ENTITY_NAME, {}, { idAttribute: 'paymentId' });

